<template>
  <nav
    class="panel header-wrap top hideOnScroll fixed top-0 left-0 w-full text-center text-size2 pointer-events-none select-none"
  >
    <div class="sections desktop flex justify-between">
      <div class="left mjpanel-left ui-menu pt-2 w-1/3 text-left">
        <span
          class="ui-menu__content cursor-pointer sidebarTrigger relative inline-block w-spc1 h-spc1 z-40 align-top"
          data-sidebar-id="1"
        >
          <i class="ui-menu__line ui-menu__line_1 absolute left-0 top-0 w-full pointer h-1"></i>
          <i class="ui-menu__line ui-menu__line_2 absolute left-0 top-0 w-full pointer h-1"></i>
          <i class="ui-menu__line ui-menu__line_3 absolute left-0 top-0 w-full pointer h-1"></i>
          <i
            class="menulabel font-anonymouse text-size1 not-italic uppercase font-semibold tracking-spc1 ml-spc1 top-0 align-baseline pl-3 inline-block mt-spc4"
          >Menu</i>
        </span>
      </div>

      <Logo title="MADISON JAMES" subtitle="IS A HARD TO FIND GOODS COMPANY." url="/" />

      <div class="right w-1/3"></div>
    </div>
  </nav>
</template>

<script>
import Logo from "./Logo";
import $ from "jquery";
export default {
  name: "ThemeHeader",
  components: {
    Logo
  },
  mounted() {
    $(document).on("click", ".mjpanel-left .ui-menu__content", function() {
      $(".mj-sidemenu").addClass("visible");
      $("html").addClass("sidebarShown");
    });
  }
};
</script>

<style scoped>
</style>